export default __webpack_public_path__ + "static/media/1783.068dabb4.png";